module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"terms":{"meta_tags":{"description":"Allgemeine Geschäftsbedingungen der CAPinside GmbH","title":"AGB"}}}}}}')
  delete Component.options._Ctor
}
